import { css } from "emotion"

export const container = css`
  padding: 20px;
`
